let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1lvsb"), load("9Zd2C")]).then(() => parcelRequire('2FMo5'));